import React, { useState, useContext } from "react";
import {
  ALL_DRUG_TEST_CATEGORIES_QUERY,
  DRUG_TEST_CATEGORY_PAGINATION_QUERY
} from "../../../graphql/DrugTests/DrugTestCategories.graphql";
import DrugTestCategoryFilters from "./DrugTestCategoryFilters";
import DataTable from "../../../components/DataTable";
import { DRUG_TEST_CATEGORY_COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";
import { AddDrugTestCategoryForm } from "../../../components/DrugTests";
import { ModalContext } from "../../../components/ModalProvider";
import { getFilterState, saveFilterState } from "../../../utils";

const DrugTestCategoriesPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("DRUG_TEST_CATEGORY_FILTERS", {
    Status: true
  });
  const { setModalOpen } = useContext(ModalContext);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);

  const handleSetFilters = inputs => {
    saveFilterState("DRUG_TEST_CATEGORY_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={DrugTestCategoryFilters}
        columns={DRUG_TEST_CATEGORY_COLUMNS}
        filters={filters}
        name="DrugTestCategorys"
        query={ALL_DRUG_TEST_CATEGORIES_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Drug Test Categories"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddDrugTestCategoryForm
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
      <DataTable
        columns={DRUG_TEST_CATEGORY_COLUMNS}
        dataQuery={ALL_DRUG_TEST_CATEGORIES_QUERY}
        initialSortBy={[{ id: "Description", desc: false }]}
        name="DrugTestCategory"
        paginationQuery={DRUG_TEST_CATEGORY_PAGINATION_QUERY}
        where={filters}
        onRowClick={data => {
          setModalOpen(
            true,
            <AddDrugTestCategoryForm
              data={data}
              onComplete={() => setModalOpen(false, "")}
            />
          );
        }}
      />
    </React.Fragment>
  );
};
DrugTestCategoriesPage.propTypes = {};
export default DrugTestCategoriesPage;
